import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import Agenda from "./pages/Agenda";
import Condominios from "./pages/Condominios";
import CondominioDetail from "./pages/CondominioDetail";
import EmpresasCondominio from "./pages/EmpresasCondominio";
import Registros from "./pages/Registros";
import Consultas from "./pages/Consultas";
import Orcamentos from "./pages/Orcamentos";
import AdminUsers from "./pages/AdminUsers";
import Relatorios from "./pages/Relatorios";
import AdminRoute from "./components/AdminRoute";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/agenda" element={<Agenda />} />
              <Route path="/condominios" element={<Condominios />} />
              <Route path="/condominios/:id" element={<CondominioDetail />} />
              <Route path="/empresas-condominio" element={<EmpresasCondominio />} />
              <Route path="/registros" element={<Registros />} />
              <Route path="/consultas" element={<Consultas />} />
              <Route path="/orcamentos" element={<Orcamentos />} />
              <Route path="/admin/users" element={<AdminRoute><AdminUsers /></AdminRoute>} />
              <Route path="/relatorios" element={<AdminRoute><Relatorios /></AdminRoute>} />
              {/* Legacy redirects */}
              <Route path="/servicos" element={<Navigate to="/registros" replace />} />
              <Route path="/ocorrencias" element={<Navigate to="/registros" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
